export class EditNotes{
  vibrationId:string;
  notes: EditNote[] = [];
  addNote(note:EditNote){
    this.notes.push(note);
  }
}

export class EditNote {
  value:string;
  constructor(value){
    this.value = value;
  }
}


